export default __webpack_public_path__ + "static/for-buyers-2166c68acd7e2ae16dbc98b1b952d50f.jpeg";